var Clients = $.extend(false, BaseModule ,{
    api_route : 'clients',

    data : {
		module		: 'clients',
		page		: 1,
		limit		: 40,
		sort_term	: 'id',
		sort_way	: 'DESC',
        view        : 'list',
        hosted_shop : 1,
        with        : 'logo_file',
        details_with: 'logo_file:logo_file_dark:logo_file_light:products:manufacturers:categories:users:languages',
        pagination  : true
	},
	sync:function(id){
		 var module = this,module_name = module.data.module;
	
		 var url = API + 'clients/'+id+'/sync';
		 $.ajax({
            url : url,
            method:'POST',
            data: {
                id : id
            }, error:function(){
                GlobalModule.show_message('danger','Something went wrong');
            },
            success:function(data){
                if(data.status == 'ok'){
                	$('#last-sync').html(data.sync_time);
                	 alert(data.message);
                }else{
                	GlobalModule.show_message('danger','Something went wrong');
                }
               

            }
        });


   },

	init:function(){}
});

$(document).ready(function(){
	Clients.init();
});